import type { IFormsSearchMeta, IFormsSearchResponse } from '@/composables/services/types/forms';

export const FORMS_DEFAULT_LIMIT = 20;
export const FORMS_MAX_LIMIT = 100;

export interface IFormsPaginationParams {
    start?: number;
    limit?: number;
    /** @deprecated Use start/limit. Converted to offset when start is omitted. */
    page?: number;
}

export function resolvePaginationParams(params: IFormsPaginationParams = {}): { limit: number; start: number } {
    const limit = params.limit ?? FORMS_DEFAULT_LIMIT;
    const start = params.start ?? (params.page != null ? (params.page - 1) * limit : 0);
    return { limit, start };
}

export function toPaginationQuery(params: IFormsPaginationParams = {}): Record<string, string> {
    const { limit, start } = resolvePaginationParams(params);
    return {
        limit: String(limit),
        start: String(start),
    };
}

export async function fetchAllPaginatedPages<T>(
    fetchPage: (start: number, limit: number) => Promise<IFormsSearchResponse<T>>,
    pageSize: number = FORMS_MAX_LIMIT
): Promise<T[]> {
    const items: T[] = [];
    let start = 0;
    let hasMore = true;

    while (hasMore) {
        const response = await fetchPage(start, pageSize);
        items.push(...response.data);
        hasMore = response.meta.hasMore;
        start += pageSize;
    }

    return items;
}

export function getFilteredCount<T>(response: IFormsSearchResponse<T>): number {
    return response.meta.filtered;
}
